import TableSortLabel from '@material-ui/core/TableSortLabel';

/** @deprecated */
export default TableSortLabel;
